
import Form from "./Form.vue";
import LinkData from "./LinkData";
import { mapGetters } from "vuex";

export default {
  name: "app-link-create",
  data() {
    return {
      link: new LinkData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
